import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  .component_field_help {
    display: flex;
    align-items: flex-start;
    column-gap: 8px;
    white-space: nowrap;
    margin-top: 12px;
  }
`;

export default Wrapper;

export const OptionRender = styled.div`
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  column-gap: 16px;
  padding: 12px 0;
  .component_select_ad_categories {
    .component_select_ad_categories_title {
      font-size: 16px;
      font-weight: 600;
      line-height: 142%;
      color: ${color.black2};
      white-space: normal;
    }
    .component_select_ad_categories_desc {
      font-size: 14px;
      font-weight: 400;
      line-height: 142%;
      color: ${color.black3};
      white-space: normal;
    }
  }
`;
